import React, { useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Modal } from '@mui/material';
import { boxStyle } from '../styles';
import { Link, Project } from '../../../StateContext';
import { Add } from '@mui/icons-material';
import AddToDo from './addToDo';
import { useLanguage } from '../../../Services/LanguageContext';

interface IProps {
    link?: Link[];
    project: Project;
}

const ToDoList = (props: IProps) => {
    const [checked, setChecked] = React.useState([0]);
    const [toDoList, setToDoList] = useState<string[]>([]);
    const [open, setOpen] = useState(false);
    const { t } = useLanguage();

    const handleToggle = (value: number) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    return (
        <React.Fragment>
            <Button
                color='secondary'
                variant='outlined'
                onClick={() => {
                    setOpen(true);
                }}
            >
                {t('toDoList')}
            </Button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle}>
                    <List
                        sx={{
                            width: '100%',
                            maxWidth: 360,
                            bgcolor: 'bg-paper',
                        }}
                    >
                        {props.project.todos.map((value) => {
                            const labelId = `checkbox-list-label-${value}`;

                            return (
                                <ListItem
                                    key={value}
                                    secondaryAction={
                                        <IconButton
                                            edge='end'
                                            aria-label='edit'
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    }
                                    disablePadding
                                    className='bg-gray'
                                >
                                    <ListItemButton
                                        role={undefined}
                                        onClick={handleToggle(value)}
                                        dense
                                    >
                                        <ListItemIcon>
                                            <Checkbox
                                                edge='start'
                                                checked={checked.includes(
                                                    value
                                                )}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{
                                                    'aria-labelledby': labelId,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            id={labelId}
                                            primary={value.title}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                    </List>
                    <AddToDo project={props.project} />
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default ToDoList;
